import { atom } from 'recoil';

type TResponse = {
  title: string | null;
  price: number | null;
  currency: string | null;
  serviceURL: string | null;
};

export type TState = {
  isLoaded: boolean;
  isError: boolean;
} & TResponse;

export const measurementAtom = atom({
  key: 'measurement',
  default: {
    isLoaded: false,
    isError: false,
    title: null,
    price: null,
    currency: null,
    serviceURL: null,
  } as TState,
});
